import React, { useCallback } from "react";
import { FormControl, FormControlLabel, Grid, Radio, RadioGroup, Typography } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../store";
import { setPreferencesPartial } from "../../store/expertise/expertise.reducer";
import { Title } from "./Texts";
import {TypeSollicitationCtx} from "../../../index";
import {TypeSollicitation} from "../../../core/apis/monsisra/generated";

export default function DemandesAutourPatient() {
	const dispatch = useAppDispatch();

	const typeSollicitation = React.useContext(TypeSollicitationCtx);

	const text = typeSollicitation === TypeSollicitation.TeleExpertise ? "de télémédecine" : "d'appui";


	const setUseMonSisraCb = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			dispatch(
				setPreferencesPartial({
					centragePatient: e.target.value === "true",
				})
			);
		},
		[dispatch]
	);
	const { preferences } = useAppSelector((s) => s.expertise);

	if (!preferences) return null;

	return (
		<Grid container direction={"column"} spacing={2}>
			<Grid item>
				<Title text={"Gestion des demandes autour d'un patient"} />
			</Grid>
			<Grid item>
				<FormControl component="fieldset">
					<RadioGroup value={preferences.centragePatient + ""} onChange={setUseMonSisraCb} name="radio-buttons-group">
						<FormControlLabel
							value={"true"}
							control={<Radio />}
							label={
								<Grid container alignItems={"center"} spacing={0.5}>
									<Grid item>Je souhaite que les demandes {text} qui me sont adressées</Grid>
									<Grid item>
										<Typography color={"secondary"} fontWeight={"bold"}>
											contiennent l'identité du patient
										</Typography>
									</Grid>
								</Grid>
							}
						/>
						<FormControlLabel
							value={"false"}
							control={<Radio />}
							label={
								<Grid container alignItems={"center"} spacing={0.5}>
									<Grid item>Je laisse la possibilité au demandeur d'</Grid>
									<Grid item>
										<Typography color={"secondary"} fontWeight={"bold"}>
											anonymiser
										</Typography>
									</Grid>
									<Grid item>ses demandes {text}</Grid>
								</Grid>
							}
						/>
					</RadioGroup>
				</FormControl>
			</Grid>
		</Grid>
	);
}
